module.exports = __webpack_public_path__ + "static/media/publicizzazione-corsi.e202f52b.odt";